import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import Clubs from './pages/Clubs';
import GetInvolved from './pages/GetInvolved';
import AdminVolunteers from './pages/AdminVolunteers';
import AdminPartnerships from './pages/AdminPartnerships';
import BeImmortal from './pages/BeImmortal';
import MogulManifest from './pages/MogulManifest';
import ProsperityProject from './pages/ProsperityProject';
import CommunityService from './pages/CommunityService';
import ClubsLanding from './pages/ClubsLanding';
import BookPage from './pages/BookPage';
import Partners from './pages/Partners';
import YouthSports from './pages/YouthSports';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BigIkeRevival from './pages/BigIkeRevival';
import Events from './pages/Events';
import AdminEvents from './pages/AdminEvents';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import TurkeyDrive from './pages/TurkeyDrive';
import AdminTurkeyDrive from './pages/AdminTurkeyDrive';
import { Toaster } from './components/ui/sonner';

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id synchronously during render (before any route check)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/clubs" element={<Clubs />} />
        <Route path="/clubs/all" element={<ClubsLanding />} />
        <Route path="/clubs/be-immortal" element={<BeImmortal />} />
        <Route path="/clubs/mogul-manifest" element={<MogulManifest />} />
        <Route path="/clubs/prosperity-project" element={<ProsperityProject />} />
        <Route path="/community-service" element={<CommunityService />} />
        <Route path="/youth-sports" element={<YouthSports />} />
        <Route path="/big-ike-revival" element={<BigIkeRevival />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/get-involved" element={<GetInvolved />} />
        <Route path="/events" element={<Events />} />
        <Route path="/turkey-drive" element={<TurkeyDrive />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/events" element={<AdminEvents />} />
        <Route path="/admin/turkey-drive" element={<AdminTurkeyDrive />} />
        <Route path="/admin/volunteers" element={<AdminVolunteers />} />
        <Route path="/admin/partnerships" element={<AdminPartnerships />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
